import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-accent-darker text-white py-2 px-4 shadow-md flex justify-center items-center gap-3 text-sm md:text-base font-medium" data-id="element-80">
      <Timer className="w-5 h-5 animate-pulse" data-id="element-81" />
      <span data-id="element-82">La oferta termina en:</span>
      <div className="flex gap-1 font-oswald text-lg tracking-wider" data-id="element-83">
        <span className="bg-black/20 px-2 py-0.5 rounded" data-id="element-84">
          {String(timeLeft.hours).padStart(2, '0')}
        </span>
        :
        <span className="bg-black/20 px-2 py-0.5 rounded" data-id="element-85">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        :
        <span className="bg-black/20 px-2 py-0.5 rounded" data-id="element-86">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}